const BaseComponent = require('base/base-component');

class HomeBlock extends BaseComponent {
  init () {
    // add new tag - 3天内的文章打标记【new】
    const $pubTime = this.$el.find('.pub-time');
    $pubTime.each((_, el) => {
      let timeString = $(el).data('value') + '';
      if (timeString) {
        timeString = typeof timeString == 'number' ? timeString.toString() : timeString;
        timeString = timeString.replace('CST', 'GMT+0800');
      }
      if (Date.now() - new Date(timeString).getTime() < 3 * 24 * 60 * 60 * 1000) {
        $(el).before($('<i class="iconfont icon-newchunse"></i>'));
      }
    });
  }
}

module.exports = HomeBlock;
